export default __webpack_public_path__ + "static/media/cert-ngo-HKIRC.0a13b323.jpg";